import { emeraldRequest } from '../../../common/api/emerald-request';
import { PaidActionRequest } from '../../interfaces/PaidActionRequest';
import { IReceipt } from '../../../common/interfaces/dtos/IReceipt';
import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export function postPaidOut(paidOutRequest: PaidActionRequest): Promise<IReceipt[]> {
  const axiosConfig: AxiosRequestConfig = {
    url: '/operation-management/paid-out',
    method: 'POST',
    data: paidOutRequest,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };

  return emeraldRequest(emeraldRequestParams);
}
